import type { IEnrichButtonCellProps } from "app/components/React/Table/cells/EnrichButtonCell";
import { EnrichButtonCell } from "app/components/React/Table/cells/EnrichButtonCell";

import { RankTrackerTooltip } from "app/components/campaigns/shared/RankTrackerTooltip";

export const RTEnrichButtonCell = (props: IEnrichButtonCellProps) => {
    return (
        <EnrichButtonCell
            {...props}
            tooltipComponent={RankTrackerTooltip}
        />
    );
};
